/**
 * Largest exercise video the upload takes: 100 MiB, which users read as "100 MB".
 * The scanner (clamav-rest MAX_FILE_SIZE) and the proxy body limit sit above it,
 * see infra/ansible/roles/therame_stack.
 */
export const EXERCISE_VIDEO_MAX_BYTES = 100 * 1024 * 1024;
/** Why an exercise video upload job failed; the job status and the socket event carry it. */
export var ExerciseVideoUploadFailure;
(function (ExerciseVideoUploadFailure) {
    /** The virus scan flagged the file. */
    ExerciseVideoUploadFailure["INFECTED"] = "INFECTED";
    /** ffmpeg could not read or transcode the file. */
    ExerciseVideoUploadFailure["UNPROCESSABLE"] = "UNPROCESSABLE";
    /** Anything else (scanner down, worker crash); retrying the same file may work. */
    ExerciseVideoUploadFailure["FAILED"] = "FAILED";
})(ExerciseVideoUploadFailure || (ExerciseVideoUploadFailure = {}));
//# sourceMappingURL=exercise-video-upload.js.map